export function hasNoRealnameApplication(profile = {}) {
  // 仅将接口明确的未申请状态（或尚无学生档案）视作需要提示。
  // 待处理、通过、驳回等状态都代表已经申请，不以“尚未通过”替代“尚未申请”。
  if (typeof profile.realnameApplied === 'boolean') return !profile.realnameApplied
  const status = String(profile.realnameStatus || '').trim()
  return !status || status === 'UNVERIFIED'
}

export function realnameStatusText(profile = {}) {
  const status = String(profile.realnameStatus || 'UNVERIFIED')
  return {
    UNVERIFIED: '尚未申请',
    PENDING: '待审核',
    PROCESSING: '认证处理中',
    VERIFIED: '已实名认证',
    REJECTED: '认证未通过',
    FAILED: '认证未通过',
    已认证: '已实名认证',
  }[status] || '认证状态待确认'
}

export async function checkRealnameForRegistration({ getProfile, onBlocked }) {
  // 查询失败向调用端抛出，不能把失败当作审核通过而继续报名。
  const profile = await getProfile()
  if (profile && profile.realnameStatus === 'VERIFIED') return true
  onBlocked(profile || {})
  return false
}

export function createRealnameLoginCheck({ getToken, getAccount, getProfile, onOpen }) {
  let generation = 0
  let checkingToken = ''
  let checkedToken = ''
  return {
    reset() {
      generation++
      checkingToken = ''
      checkedToken = ''
    },
    async check() {
      const token = getToken()
      if (!token || token === checkingToken || token === checkedToken) return
      const request = ++generation
      checkingToken = token
      try {
        const account = await getAccount()
        if (request !== generation || getToken() !== token) return
        // 学生资料接口只用于学生账号，工作人员登录不触发实名认证提示。
        if (!(account.roles || []).includes('STUDENT')) {
          checkedToken = token
          return
        }
        const profile = await getProfile()
        // 防止退出或切换账号后，旧请求的响应再次打开弹框。
        if (request !== generation || getToken() !== token) return
        checkedToken = token
        if (hasNoRealnameApplication(profile)) onOpen(profile)
      } catch (error) {
        // 查询失败不代表未申请；请求封装负责显示真实接口错误。
      } finally {
        if (request === generation) checkingToken = ''
      }
    },
  }
}
